import 'rc-slider/assets/index.css'
import './CustomRangeSlider.scss'

import React, { useEffect, useRef, useState } from 'react'
import Slider from 'rc-slider'

export default function CustomRangeSlider({
  handleMusicVolume,
  handleBgVolume,
  handleVolume
}) {
  const outputContainer = useRef(null)
  const [musicValue, setMusicValue] = useState(50)
  const [bgValue, setBgValue] = useState(50)
  const [volumeValue, setVolumeValue] = useState(50)

  useEffect(() => {
    if (handleMusicVolume) {
      outputContainer.current.style.marginLeft = `${musicValue}%`
      handleMusicVolume(musicValue)
    } else if (handleBgVolume) {
      outputContainer.current.style.marginLeft = `${bgValue}%`
      handleBgVolume(bgValue)
    } else {
      outputContainer.current.style.marginLeft = `${volumeValue}%`
      handleVolume(volumeValue)
    }
  })

  function handleOnChange(value) {
    if (handleMusicVolume) {
      setMusicValue(value.toFixed(0))
      handleMusicVolume(musicValue)
    } else if (handleBgVolume) {
      setBgValue(value.toFixed(0))
      handleBgVolume(bgValue)
    } else {
      setVolumeValue(value.toFixed(0))
      handleVolume(volumeValue)
    }
  }

  return (
    <div className='slider-container mb-2 position-relative'>
      <small
        className='rc-slider-output d-block text-center mb-2 d-sm-none'
        ref={outputContainer}
      >
        {(handleMusicVolume && musicValue) ||
          (handleBgVolume && bgValue) ||
          volumeValue}
        %
      </small>
      <Slider
        className='ms-0 ms-sm-2'
        step={0.1}
        value={
          (handleMusicVolume && musicValue) ||
          (handleBgVolume && bgValue) ||
          volumeValue
        }
        onChange={handleOnChange}
      />
    </div>
  )
}
